
/*
 * ALONE HABIB — Carrousel des grilles produits
 * Navigation souris, clavier, tactile et variantes couleur.
 */

(function () {
  "use strict";

  function getCarousel(element) {
    return element && element.closest
      ? element.closest(".ah-grid-carousel")
      : null;
  }

  function getSlides(carousel) {
    return Array.from(
      carousel.querySelectorAll(".ah-grid-carousel__slide")
    );
  }

  function showSlide(carousel, requestedIndex) {
    if (!carousel) return;

    const slides = getSlides(carousel);
    const count = slides.length;

    if (!count) return;

    const index = ((requestedIndex % count) + count) % count;

    carousel.dataset.ahIndex = String(index);

    slides.forEach(function (slide, position) {
      const active = position === index;

      slide.classList.toggle("is-active", active);
      slide.setAttribute("aria-hidden", active ? "false" : "true");
    });

    carousel.querySelectorAll(".ah-grid-carousel__dot")
      .forEach(function (dot, position) {
        dot.classList.toggle("is-active", position === index);
      });
  }

  function move(carousel, direction) {
    const index = Number(carousel.dataset.ahIndex || 0);
    showSlide(carousel, index + direction);
  }

  function initialize(carousel) {
    if (carousel.dataset.ahInitialized === "true") return;
    if (getSlides(carousel).length < 2) return;

    carousel.dataset.ahInitialized = "true";
    showSlide(carousel, 0);
  }

  function initializeAll(root) {
    if (!root || root.nodeType !== 1) return;

    if (root.matches(".ah-grid-carousel")) {
      initialize(root);
    }

    root.querySelectorAll(".ah-grid-carousel").forEach(initialize);
  }

  function getProductCard(element) {
    return element.closest(".grid-item");
  }

  function selectColor(swatch) {
    const card = getProductCard(swatch);
    if (!card) return false;

    const carousel = card.querySelector(".ah-grid-carousel");
    if (!carousel) return false;

    const imageUrl = swatch.getAttribute("data-variant-image");
    if (!imageUrl) return false;

    const slides = getSlides(carousel);
    if (!slides.length) return false;

    // Recherche d'une photo déjà présente dans le carrousel.
    const targetUrl = new URL(imageUrl, window.location.href);
    const targetPath = targetUrl.pathname;

    let matchingIndex = -1;

    slides.forEach(function (slide, index) {
      const image = slide.querySelector("img");
      if (!image || matchingIndex !== -1) return;

      const candidates = [
        image.currentSrc,
        image.getAttribute("src"),
        image.getAttribute("data-src")
      ].filter(Boolean);

      const match = candidates.some(function (candidate) {
        try {
          const candidateUrl = new URL(candidate, window.location.href);

          // Shopify peut servir plusieurs tailles de la même photo.
          const normalize = function (path) {
            return path
              .replace(/_(\d+x\d*|x\d+)(?=\.[^.]+$)/, "")
              .replace(/_(\d+x\d*|x\d+)(?=\.[^.]+$)/, "");
          };

          return normalize(candidateUrl.pathname) === normalize(targetPath);
        } catch (error) {
          return false;
        }
      });

      if (match) matchingIndex = index;
    });

    if (matchingIndex >= 0) {
      showSlide(carousel, matchingIndex);
    } else {
      // Si l'image de variante n'est pas parmi les 5 photos,
      // on l'affiche temporairement dans la première diapositive.
      const firstSlide = slides[0];
      const image = firstSlide.querySelector("img");

      if (!image) return false;

      if (!image.dataset.ahOriginalSrc) {
        image.dataset.ahOriginalSrc = image.getAttribute("src") || "";
        image.dataset.ahOriginalSrcset = image.getAttribute("srcset") || "";
      }

      image.removeAttribute("srcset");
      image.removeAttribute("sizes");
      image.setAttribute("src", imageUrl);

      showSlide(carousel, 0);
    }

    // Marque visuellement la couleur choisie.
    card.querySelectorAll(".grid-product__colors .color-swatch")
      .forEach(function (item) {
        item.classList.toggle("is-active", item === swatch);
      });

    return true;
  }

  // Flèches : empêcher l'ouverture de la fiche produit.
  document.addEventListener("pointerdown", function (event) {
    if (!(event.target instanceof Element)) return;

    const arrow = event.target.closest(".ah-grid-carousel__arrow");
    if (arrow) event.stopPropagation();
  }, true);

  document.addEventListener("click", function (event) {
    if (!(event.target instanceof Element)) return;

    const arrow = event.target.closest(".ah-grid-carousel__arrow");
    if (!arrow) return;

    const carousel = getCarousel(arrow);
    if (!carousel) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    move(
      carousel,
      arrow.classList.contains("ah-grid-carousel__arrow--next") ? 1 : -1
    );
  }, true);

  // Clic sur les pastilles de couleur.
  document.addEventListener("click", function (event) {
    if (!(event.target instanceof Element)) return;

    const swatch = event.target.closest(
      ".grid-product__colors .color-swatch[data-variant-image]"
    );

    if (!swatch) return;

    const card = getProductCard(swatch);
    if (!card || !card.querySelector(".ah-grid-carousel")) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    selectColor(swatch);
  }, true);

  // Navigation au clavier.
  document.addEventListener("keydown", function (event) {
    if (!(event.target instanceof Element)) return;

    const arrow = event.target.closest(".ah-grid-carousel__arrow");
    if (!arrow) return;

    if (event.key !== "Enter" && event.key !== " ") return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const carousel = getCarousel(arrow);

    if (carousel) {
      move(
        carousel,
        arrow.classList.contains("ah-grid-carousel__arrow--next") ? 1 : -1
      );
    }
  }, true);

  // Défilement tactile.
  let touchStartX = 0;
  let touchStartY = 0;
  let activeCarousel = null;
  let suppressNextClick = false;

  document.addEventListener("touchstart", function (event) {
    activeCarousel = null;

    if (event.touches.length !== 1) return;
    if (!(event.target instanceof Element)) return;

    const carousel = getCarousel(event.target);
    if (!carousel) return;

    activeCarousel = carousel;
    touchStartX = event.touches[0].clientX;
    touchStartY = event.touches[0].clientY;
  }, { passive: true, capture: true });

  document.addEventListener("touchend", function (event) {
    if (!activeCarousel || !event.changedTouches.length) return;

    const carousel = activeCarousel;
    activeCarousel = null;

    const deltaX = event.changedTouches[0].clientX - touchStartX;
    const deltaY = event.changedTouches[0].clientY - touchStartY;

    if (
      Math.abs(deltaX) > 30 &&
      Math.abs(deltaX) > Math.abs(deltaY) * 1.2
    ) {
      move(carousel, deltaX < 0 ? 1 : -1);
      suppressNextClick = true;
    }
  }, { passive: true, capture: true });

  document.addEventListener("click", function (event) {
    if (!suppressNextClick) return;
    if (!(event.target instanceof Element)) return;

    if (getCarousel(event.target)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    suppressNextClick = false;
  }, true);

  function start() {
    initializeAll(document.documentElement);

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) initializeAll(node);
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }

  document.addEventListener("shopify:section:load", function (event) {
    initializeAll(event.target);
  });
})();

